<div class="card-container">
  <div class="card-header">
    <div class="icon-wrapper">
      <img *ngIf="tool.icon && !imageError" [src]="tool.icon" [alt]="tool.name" class="tool-icon" (error)="onImageError()">
      <span *ngIf="!tool.icon || imageError" class="tool-icon-fallback">{{ tool.name.charAt(0) }}</span>
    </div>
  </div>

  <div class="card-content">
    <h3 class="tool-name">{{tool.name}}</h3>
    <p class="tool-description">{{tool.description}}</p>

    <div class="card-footer">
      <span class="category-badge">{{tool.category}}</span>
      <button class="open-btn" (click)="openTool()" title="Open {{tool.name}}">
        Open Tool →
      </button>
    </div>
  </div>
</div>
